<script>
  import Router, { replace } from "svelte-spa-router";
  import Add from "./Add.svelte";
  import Edit from "./Edit.svelte";
  import Detail from "./Detail.svelte";
  import LayoutSidebar from "../../layouts/LayoutSidebar.svelte";
  import List from "./List.svelte";
  import { onMount } from "svelte";
  import { checkRoleModule } from "../../utils/utils";
  import { roleModules } from "../../stores/store";
  import { ONE_MODULE } from "../../utils/const";

  const prefix = "/ones";
  const routes = {
    "/": List,
    "/add/:type": Add,
    "/:_id/:type/edit": Edit,
    "/:_id/:type/detail": Detail,
  };

  onMount(() => {
    if (!checkRoleModule($roleModules, ONE_MODULE)) {
      replace("/");
    }
  });

  let openSidebar = false;
</script>

<LayoutSidebar bind:openSidebar>
  <div class="md:flex pt-14 mt-8 md:mt-4">
    <div class="w-full md:ml-64">
      <Router {routes} {prefix} />
    </div>
  </div>
</LayoutSidebar>
